<template>
<div class="fc-page fc-page-journal"><header class="fc-child-heading"><h2>课时流水查询</h2><p>追踪课时的增加、扣除与余额变化</p></header>
 <section class="fc-filters" aria-label="课时流水查询筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>追踪课时的增加、扣除与余额变化</span></div><form @submit.prevent="queryClicked"><div class="fc-filter-grid"><div class="fc-filter-cell"><v-select :items="selectCourseList" v-model="query.courseId" item-text="courseName"
								item-value="id" label="课程" dense outlined clearable color="#d9363e" hide-details aria-label="课程"></v-select></div>
<div class="fc-filter-cell"><v-text-field clearable dense label="学号" outlined v-model="query.studentNo" color="#d9363e" hide-details aria-label="学号">
							</v-text-field></div>
<div class="fc-filter-cell"><studentSearchBox class="fc-student-search" @inputValue="setInputValue"></studentSearchBox></div>
<div class="fc-filter-cell"><v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
							    transition="scale-transition" offset-y
								min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined color="#d9363e" hide-details aria-label="创建开始日期"></v-text-field>
								</template>
								<v-date-picker v-model="query.start"  @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e">
								</v-date-picker>
							</v-menu></div>
<div class="fc-filter-cell"><v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
								 transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.end" label="创建结束日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined color="#d9363e" hide-details aria-label="创建结束日期"></v-text-field>
								</template>
								<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn" color="#d9363e">
								</v-date-picker>
							</v-menu></div></div><div class="fc-filter-bottom"><span>查询当前校区的记录</span><div class="fc-filter-actions"><v-btn type="submit" class="fc-query" depressed color="#d9363e" dark :loading="query.loading"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></div></form></section>
 <section class="fc-records" aria-label="课时账户流水"><div class="fc-list-heading"><h3>课时账户流水</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span><span class="fc-list-note">按业务时间核对每次课时变动</span></div>
 <v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table fc-table-journal" :mobile-breakpoint="0" disable-pagination hide-default-footer item-key="id" loading-text="正在加载，请稍候…" no-data-text="暂无符合条件的记录"><template v-slot:item.inOut="{item}">
				<span v-if="item.inOut=='1'" class="fc-change-in">增加</span>
				<span v-if="item.inOut=='2'">减少</span>
			</template>
<template v-slot:item.amount="{item}">
				<span v-if="item.inOut=='1'" class="fc-change-in">+{{item.amount}}</span>
				<span v-if="item.inOut=='2'">-{{item.amount}}</span>
			</template>
<template v-slot:item.studentName="{item}"><strong class="fc-student-name">{{item.studentName}}</strong></template>
<template v-slot:item.memo="{item}"><div class="fc-memo">{{item.memo}}</div></template>
<template v-slot:item.lastAmount="{item}"><span class="fc-number" :class="{'fc-negative':Number(item.lastAmount)<0}">{{item.lastAmount}}</span></template>
<template v-slot:item.balanceAmount="{item}"><span class="fc-number" :class="{'fc-negative':Number(item.balanceAmount)<0}">{{item.balanceAmount}}</span></template></v-data-table>
 <div class="fc-pagination"><div class="fc-page-size"><span>每页</span><v-select :items="[10,20,50,100]" @change="handleSizeChange" dense hide-details aria-label="每页数量" outlined v-model="query.size" color="#d9363e" /><span>条</span><span class="fc-total">共 {{data.total}} 条记录</span></div><v-pagination v-if="Math.ceil(data.total/query.size)>0" :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange" :total-visible="5" v-model="query.page" color="#d9363e" /></div></section></div>
</template>

<script>
	import studentSearchBox from "../../../components/student_search_box.vue"
	import utils from "../../../config/utils"
	export default {
		name: "account-journal-list",
		components:{studentSearchBox},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				data: {
					total: 0,
					headers: [
						{
							text: '课程名称',
							value: 'courseName',
							sortable: false
						},
						{
							text: '学号',
							value: 'studentNo',
							sortable: false
						},
						{
							text: '姓名',
							value: 'studentName',
							sortable: false
						},
						{
							text: '进/出',
							value: 'inOut',
							sortable: false
						},
						{
							text: '业务类型',
							value: 'bizType',
							sortable: false
						},
						{
							text: '业务前课时',
							value: 'lastAmount',
							sortable: false
						},
						{
							text: '本次课时',
							value: 'amount',
							sortable: false
						},
						{
							text: '业务后课时',
							value: 'balanceAmount',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '备注',
							align: 'left',
							value: 'memo',
							sortable: false
						},
					],
					list: [],
				},
				selectCourseList:[],
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					courseId: "",
					studentNo:"",
					studentName:""
				},
			}
		},
		created() {
	
			this.getCourseListForSelect();
			this.getTableDataList();
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			setInputValue(value){
				// 搜索框输入的值
				this.query.studentName = value;
			},
			queryShopChanged(){
				let shopId = this.query.shopId;
				this.getCourseListForSelect(shopId);
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;
				
				const shopId = utils.getCurrentShopId();

				let url = `/financial/student/account/journal/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (shopId) {
					url += "&shopId=" + shopId;
				}
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				
				if (this.query.courseId) {
					url += "&courseId=" + this.query.courseId;
				}
				if (this.query.studentNo) {
					url += "&studentNo=" + this.query.studentNo;
				}
				if (this.query.studentName) {
					url += "&studentName=" + this.query.studentName;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			inOutName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "增加";
				} else if (state === "2") {
					stName = "减少";
				}
				return stName;
			},
			inOutColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "2") {
					color = "error";
				}
				return color;
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "冻结";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			
			getCourseListForSelect(){
				const shopId = utils.getCurrentShopId();
				if (!shopId){
					return
				}
				
				const that = this;
				let url = `/edu/shop/course/list/`+shopId;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectCourseList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},

		}
	}
</script>

<style lang="scss" scoped src="../../../assets/styles/course-account.scss"></style>
